/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityCommentDto } from '../../models/community-comment-dto';

export interface CommunityCommentControllerMy$Params {
}

export function communityCommentControllerMy(http: HttpClient, rootUrl: string, params?: CommunityCommentControllerMy$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityCommentDto>>> {
  const rb = new RequestBuilder(rootUrl, communityCommentControllerMy.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityCommentDto>>;
    })
  );
}

communityCommentControllerMy.PATH = '/api/community-comments/my';
